import React from 'react';
import SeoLandingPage from '../SeoLandingPage';

const MortgageBrokersLanding = () => (
  <SeoLandingPage
    testIdPrefix="brokers-ai"
    pretitle="For Mortgage Brokers"
    title="AI-Powered Tools for"
    titleAccent="Mortgage Brokers"
    description="Shopperden plugs your mortgage practice into a live property pipeline. Get instant AI valuations, automated affordability checks, AI-drafted decision-in-principle letters, and a steady stream of pre-qualified buyers actively viewing listings on the platform."
    ctaLabel="Get pre-qualified leads"
    ctaTo="/register?role=professional"
    secondaryCtaLabel="See agent pricing"
    secondaryCtaTo="/for-agents"
    bullets={[
      { title: 'AI affordability calculator', body: 'Drop in income, deposit and credit profile — Shopperden AI returns a sane borrowing band in seconds, with the lender-criteria assumptions clearly shown.' },
      { title: 'AI-drafted DIP letters', body: 'Decision-in-principle and offer-confirmation letter templates auto-drafted in your firm\'s tone — watermarked, editable, ready for your compliance team to sign off.' },
      { title: 'Pre-qualified buyer leads', body: 'Buyers using the platform tell us their budget and deposit upfront. We route the right leads straight to brokers in their area — no cold-calling, no scraping.' },
      { title: 'Instant AI valuations on every listing', body: 'Click any property on Shopperden and get a Shopperden AI valuation band — perfect for sense-checking offers before you write a DIP.' },
      { title: 'Profile in our Pro Directory', body: 'Get a free verified profile in our Mortgage Broker directory. Buyers see your speciality, languages, and response time — and book a free 15-minute call.' },
      { title: 'India: RBI e-Mandate alerts', body: 'For Indian brokers, we send pre-debit notifications to your borrower clients on EMI cycles via Resend — RBI-compliant, fully automated.' },
    ]}
    faq={[
      { q: 'How do I get the leads?', a: 'After you sign up as a professional and complete the verification (FCA / RBI / FSCO depending on country), buyers in your service area can book a free 15-minute call directly from your Pro Directory profile. The platform also surfaces high-intent buyers (those who unlocked seller contact) to you in real-time.' },
      { q: 'Is there a per-lead fee?', a: 'No. You pay a flat monthly Pro Directory subscription. Leads are unlimited.' },
      { q: 'Can the AI write a regulated DIP I can send to a client?', a: 'The AI produces a watermarked draft. You / your compliance team review and sign off — same workflow as any DIP template. The watermark prevents the draft being passed off as final regulated advice.' },
      { q: 'Which markets is this in?', a: 'UK (FCA-regulated brokers), India (RBI-licensed DSAs / fintech partners) and Canada (FSCO / FSRA-licensed brokers in Ontario, BC, Alberta).' },
      { q: 'Do you integrate with my existing CRM?', a: 'Yes — webhooks for HubSpot, Salesforce and Pipedrive. Leads flow straight into your pipeline tagged Shopperden-Lead so you can track conversion.' },
    ]}
    seoTitle="AI-Powered Tools for Mortgage Brokers | Shopperden"
    seoDescription="AI affordability checks, AI-drafted DIP letters, pre-qualified buyer leads and a free Pro Directory profile. For UK FCA, India RBI and Canada FSCO brokers."
    softwareApplication={{
      name: 'Shopperden Mortgage Broker AI Suite',
      category: 'FinanceApplication',
      subCategory: 'MortgageApplication',
      description: 'AI-powered tools for mortgage brokers — affordability checks, decision-in-principle letter drafting, pre-qualified buyer leads, and an integrated Pro Directory.',
      features: [
        'AI affordability calculator',
        'AI-drafted DIP letters',
        'Pre-qualified buyer lead routing',
        'Instant AI property valuations',
        'Pro Directory profile',
        'CRM integrations (HubSpot, Salesforce, Pipedrive)',
      ],
      rating: { value: '4.7', count: '88' },
    }}
  />
);

export default MortgageBrokersLanding;
